import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, EMPTY } from "rxjs";
import "rxjs/add/operator/catch";
import { environment } from "src/environments/environment.prod";

@Injectable({
    providedIn: "root",
})
export class UploadFilesService {
    private url: string;

    constructor(private http: HttpClient) {
        this.url = environment.api + "/api/customer/upload";
    }

    uploadFile(file: File) {
        const formData: FormData = new FormData();

        formData.append("file", file);

        return this.http.post(this.url, formData).catch((error: any) => {
            return EMPTY;
        });
    }
}
